import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH } from "../variables";
import {
  StaffCompanyLawModificationRequest,
  StaffCompanyLawModificationResponse,
} from "../model/company-law-modification.model";

@Injectable({ providedIn: "root" })
export class StaffCompanyLawModificationsService {
  private readonly url: string;

  constructor(
    private readonly http: HttpClient,
    @Inject(BASE_PATH) organizationBasePath: string,
  ) {
    this.url = `${organizationBasePath.replace(/\/$/, "")}/api/v1/company-law-modifications`;
  }

  list(): Observable<StaffCompanyLawModificationResponse[]> {
    return this.http.get<StaffCompanyLawModificationResponse[]>(this.url);
  }

  getByCompanyId(
    companyId: number,
  ): Observable<StaffCompanyLawModificationResponse> {
    return this.http.get<StaffCompanyLawModificationResponse>(
      `${this.url}/company/${companyId}`,
    );
  }

  update(
    companyId: number,
    request: StaffCompanyLawModificationRequest,
  ): Observable<StaffCompanyLawModificationResponse> {
    return this.http.put<StaffCompanyLawModificationResponse>(
      `${this.url}/company/${companyId}`,
      request,
    );
  }
}
